module.exports = __webpack_public_path__ + "static/hirephotoimg-b4db5a43100dc58f2ccb64ddbc34109d.jpg";